import { ModalProps, Slider } from 'antd'
import "cropperjs/dist/cropper.css"
import { CSSProperties, FC, useRef, useState } from 'react'
import Cropper from 'react-cropper'

import { LgButton } from 'lancoo-web-ui'
import { NormalAlert } from '../alert/Alert'
import './index.scss'

interface alertParams extends ModalProps {
    // visible: boolean | undefined
    // title?: string
    btnStyle?: CSSProperties
    bodyContent?: React.ReactElement | React.ReactChild
    content?: string
    callok: () => void
    callcancel: () => void
}

interface cropperProps {
    // 图片路径
    imgSrc: any
    // 源图片信息
    oriFile: any
    // 是否可见
    visible: boolean
    // 点击确认
    callok: (afterImg: any) => void
    // 点击取消
    callcancel: () => void
    // 实例Ref
    cropperRef?: any
    //裁切比列
    ratio?: number
}

const AntdCropper: FC<cropperProps> = props => {

    const { callcancel, callok, visible, imgSrc, oriFile, ratio } = props

    const [rotate, setRotate] = useState<number>(0);
    const cropperRef = useRef<any>(null);
    const onCrop = () => {
        const imageElement: any = cropperRef?.current;
        const cropper: any = imageElement?.cropper;
        console.log(cropper.getCroppedCanvas().toDataURL());
    };

    // 旋转组件
    const setCropperRotate = (_rotate: any) => {
        const { cropper } = cropperRef?.current || {}
        if (cropper) {
            cropper.rotateTo(_rotate);
        }
    };
    const handleClick = (type: string) => {
        if (type === 'add') {
            const _rotate = rotate - 10;
            setRotate(_rotate < -180 ? -180 : _rotate);
            setCropperRotate(_rotate)
        } else {
            const _rotate = rotate + 10;
            setRotate(_rotate > 180 ? 180 : _rotate);
            setCropperRotate(_rotate)
        }
    };

    return (
        <NormalAlert
            visible={visible}
            callok={async () => {
                // callok('XXX')
                const { cropper } = cropperRef.current
                if (oriFile) {
                    await cropper.getCroppedCanvas({
                        imageSmoothingQuality: 'medium',
                        fillColor: 'transparent',
                    }).toBlob((_blob: Blob) => {
                        const formdata = new FormData()
                        formdata.append('file', _blob)
                        formdata.append('name', oriFile.name)
                        formdata.append('chunk', "0")
                        formdata.append('chunks', "1")
                        formdata.append('type', oriFile.type)
                        callok(formdata)
                    }, oriFile.type);
                }


            }}
            callcancel={callcancel}
            title="裁剪图片"
            destroyOnClose
            footer={
                <div className='normalfooter'>
                    <LgButton //className='buttonsyle1'
                        backgroundType='opacification' type='info'
                        onClick={async () => {
                            // callok('XXX')
                            const { cropper } = cropperRef.current
                            if (oriFile) {
                                await cropper.getCroppedCanvas({
                                    imageSmoothingQuality: 'medium',
                                    fillColor: 'transparent',
                                }).toBlob((_blob: Blob) => {
                                    const formdata = new FormData()
                                    formdata.append('file', _blob)
                                    formdata.append('name', oriFile.name)
                                    formdata.append('chunk', "0")
                                    formdata.append('chunks', "1")
                                    formdata.append('type', oriFile.type)
                                    callok(formdata)
                                }, oriFile.type);
                            }
                        }}
                        style={{ marginRight: 12 }}
                        value={'确定'} />
                    <LgButton // className='buttonsyle2'
                        backgroundType='transparent' border type='info'
                        value={'取消'} onClick={callcancel} />
                </div>
            }
        >
            <Cropper
                style={{ height: 400, width: "100%" }}
                zoomTo={0}//默认缩放
                dragMode="move"//拖拽模式
                minCropBoxHeight={100}//剪切框最小高度
                minCropBoxWidth={100}//剪切框最小宽度
                rotatable={true}//启用旋
                autoCropArea={1}//默认裁剪框与画布比例
                checkOrientation={false}//是否启用检查方向
                ref={cropperRef} //获取裁剪组件实例
                src={imgSrc} //原始图片路径
                guides // 显示裁剪框网格信息
                aspectRatio={ratio!=undefined ? ratio : 16 / 9} //裁切比列
            >
            </Cropper>
            <div className={"rotaArea"}>
                <button type="button" className={"btn1"} onClick={() => { handleClick('add'); }}>↻</button>
                <Slider style={{ width: "300px", height: "30px" }}
                    value={rotate}
                    min={-180} max={180}
                    tipFormatter={null}
                    onChange={(e: any) => {
                        setRotate(e)
                        setCropperRotate(e)
                    }} />
                <button type="button" className={"btn2"} onClick={() => { handleClick('duce'); }}>↺</button>
            </div>
        </NormalAlert>
    )
}

AntdCropper.defaultProps = {
    visible: false
}

export default AntdCropper